/**
 * @generated SignedSource<<22573779ab6ea7a26d9001b8b5b3a905>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CorrectExpenseInvoiceServicePeriodInput = {
  end: string;
  id: string;
  start: string;
};
export type ExpenseInvoiceServicePeriodCorrectMutation$variables = {
  input: CorrectExpenseInvoiceServicePeriodInput;
};
export type ExpenseInvoiceServicePeriodCorrectMutation$data = {
  readonly correctExpenseInvoiceServicePeriod: {
    readonly " $fragmentSpreads": FragmentRefs<"ExpenseInvoiceServicePeriod_invoice">;
  };
};
export type ExpenseInvoiceServicePeriodCorrectMutation = {
  response: ExpenseInvoiceServicePeriodCorrectMutation$data;
  variables: ExpenseInvoiceServicePeriodCorrectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExpenseInvoiceServicePeriodCorrectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExpenseInvoice",
        "kind": "LinkedField",
        "name": "correctExpenseInvoiceServicePeriod",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ExpenseInvoiceServicePeriod_invoice"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExpenseInvoiceServicePeriodCorrectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExpenseInvoice",
        "kind": "LinkedField",
        "name": "correctExpenseInvoiceServicePeriod",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "servicePeriodStart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "servicePeriodEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "servicePeriodSource",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "servicePeriodStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a65c9e137b082ae8ef8e3ce854682082",
    "id": null,
    "metadata": {},
    "name": "ExpenseInvoiceServicePeriodCorrectMutation",
    "operationKind": "mutation",
    "text": "mutation ExpenseInvoiceServicePeriodCorrectMutation(\n  $input: CorrectExpenseInvoiceServicePeriodInput!\n) {\n  correctExpenseInvoiceServicePeriod(input: $input) {\n    ...ExpenseInvoiceServicePeriod_invoice\n    id\n  }\n}\n\nfragment ExpenseInvoiceServicePeriod_invoice on ExpenseInvoice {\n  id\n  invoiceDate\n  servicePeriodStart\n  servicePeriodEnd\n  servicePeriodSource\n  servicePeriodStatus\n}\n"
  }
};
})();

(node as any).hash = "29c0fce804d4b1d3cfaf8cd163163306";

export default node;
